import { useIntl } from 'react-intl';

import LabeledValue from '#components/shared/LabeledValue.tsx';
import type { CustomerTrailerUnit } from '#domain/model/Goods.ts';

type CustomerTrailerUnitDetailsProps = {
    unit: CustomerTrailerUnit;
};

const sectionClasses = 'display-flex flex-column gap-10 bg-lightest padding-10 rounded';
const columnClasses = 'display-grid gap-10';

export const CustomerTrailerUnitDetails = ({ unit }: CustomerTrailerUnitDetailsProps) => {
    const intl = useIntl();

    const emptyPlaceholder = '-';
    const loadedLicensePlate = unit.licensePlate.loaded;
    const unloadedLicensePlate = unit.licensePlate.unloaded;

    return (
        <div data-testid={`order-stop-form-${unit.id}`} className={sectionClasses}>
            <LabeledValue
                boxed
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.customer-trailer.license-plate',
                })}
                value={unit.licensePlate.target ?? emptyPlaceholder}
            />
            <div className={`${columnClasses} grid-cols-2`}>
                <LabeledValue
                    boxed
                    label={intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.customer-trailer.license-plate',
                    })}
                    value={loadedLicensePlate ?? emptyPlaceholder}
                />
                <LabeledValue
                    boxed
                    label={intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.customer-trailer.license-plate',
                    })}
                    value={unloadedLicensePlate ?? emptyPlaceholder}
                />
            </div>
        </div>
    );
};
